import React from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../i18n/LanguageContext';
import siteImageManifest from '../data/siteImageManifest.generated.json';

export default function Home() {
  const { lang, t } = useI18n();
  const highlights = t('home.highlights');

  const highlightTargets = [
    '/produse/sticle-pet',
    '/produse/capace-manere',
    '/produse/capace-manere',
    '/produse/preforme',
    '/produse/galeti-bidoane',
    '/produse/galeti-bidoane',
    '/produse/galeti-bidoane',
  ];
  const v = typeof siteImageManifest?.generatedAt === 'string' ? siteImageManifest.generatedAt : '';
  const suffix = v ? `?v=${encodeURIComponent(v)}` : '';
  const greenImageSrc = `${process.env.PUBLIC_URL}/images/altele/${lang === 'en' ? 'yk_green_en' : 'yk_green'}.png${suffix}`;
  const carouselImageFiles = React.useMemo(
    () => ['Carusel_1.jpg', 'Carusel_2.jpg', 'Carusel_3.JPG', 'Carusel_4.jpg', 'Carusel_5.JPG'],
    []
  );
  const carouselCount = carouselImageFiles.length;
  const carouselImages = React.useMemo(() => {
    return carouselImageFiles.map((file) => `${process.env.PUBLIC_URL}/images/carusel/${file}${suffix}`);
  }, [carouselImageFiles, suffix]);

  const [active, setActive] = React.useState(0);
  const [displayed, setDisplayed] = React.useState(0);
  const [isFading, setIsFading] = React.useState(false);

  React.useEffect(() => {
    const id = setInterval(() => {
      setActive((n) => (n + 1) % carouselCount);
    }, 3000);
    return () => clearInterval(id);
  }, [carouselCount]);

  React.useEffect(() => {
    if (active === displayed) return;
    setIsFading(true);
    const id = setTimeout(() => {
      setDisplayed(active);
      setIsFading(false);
    }, 180);
    return () => clearTimeout(id);
  }, [active, displayed]);

  return (
    <section className="yk-hero">
      <div className="yk-heroGrid">
        <div className="yk-heroLeft">
          <h1 className="yk-h1">{t('home.title')}</h1>
          <p className="yk-lead">{t('home.subtitle')}</p>

          <div className="yk-ctaRow">
            <Link className="yk-btn yk-btnPrimary" to="/produse/sticle-pet">
              {t('home.ctaPrimary')}
            </Link>
            <Link className="yk-btn yk-btnGhost" to="/contact">
              {t('home.ctaSecondary')}
            </Link>
          </div>


          <div className="yk-card yk-heroCard yk-heroHighlights" aria-label={t('home.highlightsTitle')}>
            <ul className="yk-highlightsList" aria-label={t('home.highlightsTitle')}>
              {Array.isArray(highlights)
                ? highlights.map((item, index) => (
                    <li key={item} className="yk-highlightsItem">
                      <Link className="yk-highlightsLink" to={highlightTargets[index] || '/produse'}>
                        {item}
                      </Link>
                    </li>
                  ))
                : null}
            </ul>
          </div>
        </div>

        <div className="yk-heroMedia">
          <div className="yk-heroImageWrap">
            {/* Carousel viewport */}
            <div
              className="yk-carouselViewport"
              style={{ overflow: 'hidden', position: 'relative', height: '100%' }}
            >
              <div
                className="yk-carouselTrack"
                style={{
                  position: 'relative',
                  height: '100%',
                  overflow: 'hidden',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <img
                  className="yk-heroImage"
                  src={carouselImages[displayed]}
                  alt={`${t('home.heroImageAlt')} ${displayed + 1}`}
                  loading={'eager'}
                  decoding="async"
                  onError={(e) => {
                    try {
                      e.currentTarget.src = `${process.env.PUBLIC_URL}/brand/yk-mark.svg`;
                    } catch (err) {
                      // ignore
                    }
                  }}
                  style={{ width: '100%', height: '100%', display: 'block', objectFit: 'cover', opacity: isFading ? 0 : 1, transition: 'opacity 450ms ease' }}
                />
              </div>

              {/* Dots */}
              <div style={{ position: 'absolute', left: 0, right: 0, bottom: 12, display: 'flex', justifyContent: 'center', gap: 8 }}>
                {carouselImages.map((_, i) => (
                  <button
                    key={`dot-${i}`}
                    type="button"
                    aria-label={`Go to slide ${i + 1}`}
                    onClick={() => setActive(i)}
                    style={{
                      width: 12,
                      height: 12,
                      borderRadius: '50%',
                      border: 'none',
                      background: i === active ? '#222' : 'rgba(255,255,255,0.6)',
                      boxShadow: '0 0 0 1px rgba(0,0,0,0.1) inset',
                      cursor: 'pointer',
                      padding: 0,
                    }}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="yk-card yk-heroBottomMedia">
        <img
          src={greenImageSrc}
          alt={t('home.greenImageAlt')}
          className="yk-heroBottomImage"
          loading="lazy"
          decoding="async"
        />
      </div>
    </section>
  );
}
